<template>
    <div class="row cemetery-search-sector">
        <div class="col-12">
            <TableSearch
                :ref="`tblSearch-${panelId}`"
                :route="url.search"
                :startLoad="tableStartLoad"
                :settings="tableSettings"
                :columns="tableColumns"
                :externalFilters="form"
                :btnSearchFilters="false"
                :btnClearFilters="false"
                :showTitleData="false"
                :encodeParamsQueryString="['data']"
                tableWrapperClass="bg-lilac-light"
                :tableClass="tableClass"
                @search="onSearched"
                @resetSearch="onResetSearch"
                @errorLoad="showError"
            >
                <template v-slot:body="{ columns, row }">
                    <template v-for="(column, index) in columns">
                        <template v-if="column.field || column.field_label">
                            <template v-if="column.actionFnName && column.actionPermissionName && callFn(column.actionPermissionName, column)">
                                <td
                                    :key="`${column}-${index}`"
                                    :class="column.class"
                                >
                                    <button
                                        data-toggle="tooltip-city"
                                        :key="`${column}-${index}`"
                                        :title="$t(`${column.actionTitle}`)"
                                        class="btn btn-link min-w-auto font-small text-decoration-none text-align-inherit text-transform-none z-depth-0 m-0 p-0"
                                        type="button"
                                        :disabled="false"
                                        @click.prevent="callFn(column.actionFnName, row)"
                                    >
                                        {{ columnValue(row, column) }}
                                    </button>
                                </td>
                            </template>
                            <template v-else>
                                <td
                                    :key="`${column}-${index}`"
                                    :class="column.class"
                                    v-html="columnValue(row, column)"
                                ></td>
                            </template>
                        </template>
                        <template v-else>
                            <column-actions
                                :row="row"
                                :index="index"
                                :key="`${column}-${index}`"
                            >
                                <template v-if="hasGeometry(row)">
                                    <li class="list-group-item">
                                        <i
                                            class="fas fa-map-marked-alt action view-on-map"
                                            :disabled="false"
                                            data-toggle="tooltip-city"
                                            data-placement="left"
                                            :title="$t(`${translateID}.buttons.view_on_map`)"
                                            @click.prevent="onViewOnMap(row)"
                                        />
                                    </li>
                                </template>
                            </column-actions>
                        </template>
                    </template>
                </template>
            </TableSearch>
        </div>
    </div>
</template>

<script>
import SearchTableElementMixin from "../mixins/SearchTableElementMixin";

export default {
    mixins: [
        SearchTableElementMixin,
    ],
    data() {
        return {

        };
    },
}
</script>